//NEW: UI_REVAMP
import { Box } from '@chakra-ui/react';

const GlassMask = ({
	border = '1px solid white',
	borderRadius = 'inherit',
	maskOpacity = 1,
	...props
}) => {
	const mask = `linear-gradient(
    to bottom right,
    rgba(255,255,255,${maskOpacity}) 0%,
    transparent 30%,
    transparent 70%,
    rgba(255,255,255,${maskOpacity}) 100%
  )`;

	return (
		<Box
			position='absolute'
			inset={0}
			border={border}
			borderRadius={borderRadius}
			sx={{
				maskImage: mask,
				maskSize: '100% 100%',
				maskRepeat: 'no-repeat',
				WebkitMaskImage: mask,
				WebkitMaskSize: '100% 100%',
				WebkitMaskRepeat: 'no-repeat',
			}}
			pointerEvents='none'
			{...props}
		/>
	);
};

export default GlassMask;
